import React, { useMemo, ReactElement } from 'react';
import FilterContainer from '../../../components/filter-container/filter-container.component';
import FilterSelectField from '../../../components/filter-select-field/filter-select-field.component';
import MenuItemList from '../../../components/menu-item-list/menu-item-list.component';
import { FILTER_VALUE_EMPTY } from '../../../constants/system/filter-values';
import {
  FILTER_TYPE_CATEGORY, FILTER_TYPE_DEAL_ID, FILTER_TYPE_BROKER_ID, FILTER_TYPE_LENDER_ID, FILTER_TYPE_INVESTOR_ID,
  FILTER_TYPE_DEAL_CONTACT_ID, FILTER_TYPE_TYPE,
} from '../../../constants/system/filter-types';

const ActivityListFilters: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isDealActivity,
    filters,
    currentFilters,
    filterDealList,
    filterActivityTypeList,
    filterActivityCategoryList,
    filterBrokerList,
    filterLenderList,
    filterInvestorList,
    filterDealContactList,
    onSetFilterValue,
  } = props;

  const filterCategory: string = filters && filters[FILTER_TYPE_CATEGORY];
  const filterDealId: number = filters && filters[FILTER_TYPE_DEAL_ID];
  const filterType: string = filters && filters[FILTER_TYPE_TYPE];
  const filterBrokerId: number = filters && filters[FILTER_TYPE_BROKER_ID];
  const filterLenderId: number = filters && filters[FILTER_TYPE_LENDER_ID];
  const filterInvestorId: number = filters && filters[FILTER_TYPE_INVESTOR_ID];
  const filterDealContactId: number = filters && filters[FILTER_TYPE_DEAL_CONTACT_ID];

  const menuItemFilterActivityCategoryList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: filterActivityCategoryList,
    selectedValue: filterCategory,
  }), [filterActivityCategoryList, filterCategory]);

  const menuItemFilterDealList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemLabelKey: 'name',
    optionList: filterDealList,
    selectedValue: filterDealId,
  }), [filterDealList, filterDealId]);

  const menuItemFilterActivityTypeList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: filterActivityTypeList,
    selectedValue: filterType,
  }), [filterActivityTypeList, filterType]);

  const menuItemFilterBrokerList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemLabelKey: 'fullName',
    optionList: filterBrokerList,
    selectedValue: filterBrokerId,
  }), [filterBrokerList, filterBrokerId]);

  const menuItemFilterLenderList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemLabelKey: 'fullName',
    optionList: filterLenderList,
    selectedValue: filterLenderId,
  }), [filterLenderList, filterLenderId]);

  const menuItemFilterInvestorList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemLabelKey: 'fullName',
    optionList: filterInvestorList,
    selectedValue: filterInvestorId,
  }), [filterInvestorList, filterInvestorId]);

  const menuItemFilterDealContactList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemLabelKey: 'fullName',
    optionList: filterDealContactList,
    selectedValue: filterDealContactId,
  }), [filterDealContactList, filterDealContactId]);

  return (
    <FilterContainer>
      {
        isDealActivity && (
          <FilterSelectField
            filterType={FILTER_TYPE_CATEGORY}
            label="Category"
            value={currentFilters[FILTER_TYPE_CATEGORY] || FILTER_VALUE_EMPTY}
            currentFilters={currentFilters}
            menuItemList={menuItemFilterActivityCategoryList}
            onSetFilterValue={onSetFilterValue}
          />
        )
      }
      {
        !isDealActivity && (
          <FilterSelectField
            isInteger
            filterType={FILTER_TYPE_DEAL_ID}
            label="Deal"
            value={currentFilters[FILTER_TYPE_DEAL_ID] || FILTER_VALUE_EMPTY}
            currentFilters={currentFilters}
            menuItemList={menuItemFilterDealList}
            onSetFilterValue={onSetFilterValue}
          />
        )
      }
      <FilterSelectField
        filterType={FILTER_TYPE_TYPE}
        label="Type"
        value={currentFilters[FILTER_TYPE_TYPE] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterActivityTypeList}
        onSetFilterValue={onSetFilterValue}
      />
      <FilterSelectField
        isInteger
        filterType={FILTER_TYPE_BROKER_ID}
        label="Broker"
        value={currentFilters[FILTER_TYPE_BROKER_ID] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterBrokerList}
        onSetFilterValue={onSetFilterValue}
      />
      <FilterSelectField
        isInteger
        filterType={FILTER_TYPE_LENDER_ID}
        label="Lender"
        value={currentFilters[FILTER_TYPE_LENDER_ID] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterLenderList}
        onSetFilterValue={onSetFilterValue}
      />
      <FilterSelectField
        isInteger
        filterType={FILTER_TYPE_INVESTOR_ID}
        label="Investor"
        value={currentFilters[FILTER_TYPE_INVESTOR_ID] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterInvestorList}
        onSetFilterValue={onSetFilterValue}
      />
      <FilterSelectField
        isInteger
        filterType={FILTER_TYPE_DEAL_CONTACT_ID}
        label="Deal Contact"
        value={currentFilters[FILTER_TYPE_DEAL_CONTACT_ID] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterDealContactList}
        onSetFilterValue={onSetFilterValue}
      />
    </FilterContainer>
  );
});

export default ActivityListFilters;
